module.exports = __webpack_public_path__ + "static/media/t_kobo.e7ed1319.png";